import React from 'react';
import PropTypes from 'prop-types';

import Alert from 'components/alert';
import BraintreeForm, { DEFAULT_ADDRESS } from 'components/braintree/form';
import SaveButton from 'components/form/save_button';
import { put } from 'helpers/api';

export default class Editor extends React.Component {
  static propTypes = {
    billingAccount: PropTypes.shape({
      directEditToken: PropTypes.string.isRequired,
      billingAddresses: PropTypes.array.isRequired,
      gatewayClientToken: PropTypes.string.isRequired,
      gatewayPaymentMethodToken: PropTypes.string,
      product: PropTypes.string.isRequired
    }).isRequired,
    countryOptions: PropTypes.array.isRequired,
    stateOptions: PropTypes.array.isRequired
  }

  state = {
    address: null,
    cardType: null,
    errors: null,
    lastFour: null,
    nonce: null,
    saved: false,
    saving: false
  }

  clearPaymentNonce = () => this.setState({ address: null, cardType: null, lastFour: null, nonce: null })

  requestPaymentMethodNonce = (braintree) => {
    const that = this;
    const defaultAddress = DEFAULT_ADDRESS;

    braintree.requestPaymentMethod().then((response) => {
      const { details: { cardType, lastFour }, nonce } = response;
      const { billingAddresses, gatewayPaymentMethodToken } = that.props.billingAccount;
      const paymentAddress = billingAddresses.find(address => address.paymentToken == gatewayPaymentMethodToken);

      that.setState({ address: paymentAddress || defaultAddress, cardType, errors: null, lastFour, nonce });
    });
  }

  updateAddress = (name, value) => this.setState(({ address }) => ({ address: { ...address, [name]: value } }))

  disableSubmit = () => {
    const { address, nonce, saving } = this.state;
    if (saving) return true;

    return !(nonce && this.validAddress(address));
  }

  validAddress = address => (
    Object.keys(address).every(k => !!address[k] || k === 'extendedAddress') && address.postalCode.length >= 5
  )

  handleClick = () => {
    const { nonce, address } = this.state;
    const { directEditToken, product } = this.props.billingAccount;

    this.setState({ saving: true });
    put(`/billing_accounts/${directEditToken}`, { nonce, address }).then(() => {
      if (product === 'private_database') {
        location.reload();
      } else {
        this.setState({ saved: true, saving: false });
        location.reload();
      }
    }).catch((errors) => {
      this.setState({ errors, saving: false });
    });
  }

  render() {
    const { address, errors, saved, saving } = this.state;
    const { billingAccount, stateOptions, countryOptions } = this.props;

    return (
      <React.Fragment>
        {errors && <Alert messages={errors} title="The payment method could not be updated" />}
        <BraintreeForm
          address={address}
          countryOptions={countryOptions}
          gatewayClientToken={billingAccount.gatewayClientToken}
          stateOptions={stateOptions}
          vaultManager
          onAddressChange={this.updateAddress}
          onClearPaymentNonce={this.clearPaymentNonce}
          onRequestPaymentMethodNonce={this.requestPaymentMethodNonce.bind(this)}
        />
        <div className="text-right">
          <SaveButton
            disabled={this.disableSubmit()}
            label="Update Payment Info"
            notificationDuration={3000}
            notificationLabel="Saved, please wait for the page to reload."
            saved={saved}
            saving={saving}
            onClick={this.handleClick}
            onSavedAcknowledgement={() => this.setState({ saved: false })}
          />
        </div>
      </React.Fragment>
    );
  }
}
